import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { media } from 'styles/mixins';
import * as tokens from 'styles';

const Wrapper = styled.div`
  margin-top: ${tokens.spacer32};
  display: flex;
  flex-direction: column;
  ${media.mobileSmUp} {
    flex-direction: row;
  }
`;

type ButtonWrapperProps = ComponentProps<typeof Wrapper>;

const ButtonWrapper = ({ children, ...props }: ButtonWrapperProps) => (
  <Wrapper {...props}>{children}</Wrapper>
);

export default ButtonWrapper;
